/* FT PLP — proposed collection page (Oct 2026). No dependencies. */
(function () {
  var root = document.querySelector('[data-ftp]');
  if (!root) return;
  var VIEW = root.getAttribute('data-view') || '';

  function keep(href) {
    try {
      var u = new URL(href, location.origin);
      if (VIEW && !u.searchParams.get('view')) u.searchParams.set('view', VIEW);
      return u.pathname + u.search;
    } catch (e) { return href; }
  }
  function keepLinks(scope) {
    scope.querySelectorAll('a[data-keep]').forEach(function (a) { a.setAttribute('href', keep(a.getAttribute('href'))); });
  }
  keepLinks(root);

  /* ---- filter drawer */
  var drawer = root.querySelector('[data-drawer]');
  var backdrop = root.querySelector('[data-backdrop]');
  var lastFocus = null;
  if (drawer && drawer.parentNode !== document.body) document.body.appendChild(backdrop), document.body.appendChild(drawer);
  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ftp-lock');
    var f = drawer.querySelector('summary, input, button'); if (f) f.focus();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open'); backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ftp-lock');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-filters]')) { e.preventDefault(); openDrawer(); }
    else if (e.target.closest('[data-close-filters]') || e.target === backdrop) { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  var form = drawer && drawer.querySelector('[data-filter-form]');
  if (form) keepLinks(drawer);

  /* ---- live filtering: every tick / price change refreshes the results in place and the drawer stays open.
     The button reads "Show N results" and just closes the drawer. The form still submits normally without JS. */
  var reqId = 0, priceT = 0;
  function formUrl() {
    var fd = new FormData(form), u = new URL(form.getAttribute('action'), location.origin);
    fd.forEach(function (v, k) { if (v !== '') u.searchParams.append(k, v); });
    return u.pathname + u.search;
  }
  function swap(sel, doc, scope) {
    var cur = (scope || root).querySelector(sel), nx = doc.querySelector(sel);
    if (cur) cur.innerHTML = nx ? nx.innerHTML : '';
    return cur;
  }
  function setApplyLabel() {
    var b = drawer && drawer.querySelector('.ftp-apply'), c = root.querySelector('.ftp-count');
    if (!b || !c) return;
    var n = parseInt(c.textContent.replace(/[^0-9]/g, ''), 10);
    b.textContent = isNaN(n) ? 'Show results' : 'Show ' + n + ' result' + (n === 1 ? '' : 's');
  }
  function toBar() { var bar = root.querySelector('.ftp-bar'); if (bar && bar.getBoundingClientRect().top < 0) bar.scrollIntoView(); }
  function applyUrl(url, fromDrawer) {
    var id = ++reqId;
    root.classList.add('is-loading'); if (drawer) drawer.classList.add('is-loading');
    fetch(url, { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) {
      if (id !== reqId) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (!doc.querySelector('[data-grid]')) { location.href = url; return; }
      swap('.ftp-bar', doc); swap('[data-grid]', doc);
      var wrap = root.querySelector('.ftp-more-wrap'), nwrap = doc.querySelector('.ftp-more-wrap');
      if (nwrap && !wrap) { wrap = document.createElement('div'); wrap.className = 'ftp-more-wrap'; root.querySelector('[data-grid]').insertAdjacentElement('afterend', wrap); }
      if (wrap) wrap.innerHTML = nwrap ? nwrap.innerHTML : '';
      if (drawer) {
        /* keep the groups the shopper has open; refresh counts and ticks */
        var openSet = {};
        drawer.querySelectorAll('.ftp-fgroup').forEach(function (g) { openSet[g.querySelector('summary').textContent.trim().split(' (')[0]] = g.open; });
        swap('.ftp-dbody', doc, drawer);
        drawer.querySelectorAll('.ftp-fgroup').forEach(function (g) { var k = g.querySelector('summary').textContent.trim().split(' (')[0]; if (k in openSet) g.open = openSet[k]; });
        swap('.ftp-dfoot', doc, drawer);
        keepLinks(drawer);
      }
      keepLinks(root);
      setVideos(root);
      history.replaceState(null, '', keep(url));
      setApplyLabel();
      root.classList.remove('is-loading'); if (drawer) drawer.classList.remove('is-loading');
      if (!fromDrawer) toBar();
      window.dispatchEvent(new Event('scroll'));
    }).catch(function () { location.href = url; });
  }
  if (form) {
    setApplyLabel();
    form.addEventListener('change', function (e) {
      clearTimeout(priceT);
      if (e.target.type === 'number') { priceT = setTimeout(function () { priceT = 0; applyUrl(keep(formUrl()), true); }, 500); return; }
      applyUrl(keep(formUrl()), true);
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (priceT) { clearTimeout(priceT); priceT = 0; applyUrl(keep(formUrl()), true); }
      closeDrawer(); toBar();
    });
  }
  /* applied chips, Clear all and the quick-filter buttons update in place too */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.ftp-achip, .ftp-clear, .ftp-dclear, .ftp-qf');
    if (!a || !(root.contains(a) || (drawer && drawer.contains(a)))) return;
    e.preventDefault();
    applyUrl(keep(a.getAttribute('href')), !!(drawer && drawer.contains(a)));
  });

  /* ---- sort (delegated: the toolbar is replaced after each filter change) */
  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort]'); if (!sel) return;
    var u = new URL(location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    if (VIEW) u.searchParams.set('view', VIEW);
    location.href = u.pathname + u.search;
  });

  /* ---- image arrows (no swipe slider, arrows only) */
  function go(card, dir) {
    var n = parseInt(card.getAttribute('data-n'), 10) || 1;
    var i = (parseInt(card.getAttribute('data-idx'), 10) || 0) + dir;
    if (i < 0) i = 0; if (i > n - 1) i = n - 1;
    card.setAttribute('data-idx', i);
    card.classList.toggle('is-last', i === n - 1);
    var t = card.querySelector('[data-track]');
    if (t) t.style.transform = 'translateX(' + (-100 * i) + '%)';
  }
  root.addEventListener('click', function (e) {
    var p = e.target.closest('[data-prev]'), nx = e.target.closest('[data-next]');
    if (!p && !nx) return;
    e.preventDefault(); e.stopPropagation();
    go((p || nx).closest('[data-card]'), p ? -1 : 1);
  });

  /* ---- add to cart */
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-js, .cart-item-count, .CartCount, #CartCount, .cart-counter, .header-cart-count')
        .forEach(function (el) { el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
    }).catch(function () {});
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-atb]'); if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-busy')) return;
    var label = b.querySelector('.ftp-atb-l');
    b.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-id'), 10), quantity: 1 }] })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); }).then(function () {
      b.classList.remove('is-busy'); b.classList.add('is-added');
      if (label) label.textContent = 'Added to cart';
      /* same behaviour as the live theme: open the side cart (window.sideCart from simply-common.js) */
      if (window.sideCart && typeof window.sideCart.openSideCart === 'function') {
        try { window.sideCart.openSideCart(); } catch (err) { refreshCount(); }
      } else {
        refreshCount();
      }
      if (window.jQuery) { try { window.jQuery('body').trigger('added.ajaxProduct'); } catch (err) {} }
      setTimeout(function () { b.classList.remove('is-added'); if (label) label.textContent = 'Add to cart'; }, 2500);
    }).catch(function () {
      b.classList.remove('is-busy');
      if (label) label.textContent = 'Could not add — try again';
    });
  });

  /* ---- banner videos: pick the right source per viewport */
  function setVideos(scope) {
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    scope.querySelectorAll('.ftp-banner video[data-src-d]').forEach(function (v) {
      var s = mobile ? (v.getAttribute('data-src-m') || v.getAttribute('data-src-d')) : v.getAttribute('data-src-d');
      if (s && v.getAttribute('src') !== s) { v.setAttribute('src', s); v.play && v.play().catch(function () {}); }
    });
  }
  setVideos(root);

  /* ---- load more */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-loadmore]'); if (!a) return;
    e.preventDefault();
    a.classList.add('is-busy');
    fetch(a.getAttribute('href')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = root.querySelector('[data-grid]');
      var next = doc.querySelector('[data-grid]');
      if (next) Array.prototype.slice.call(next.children).forEach(function (c) { grid.appendChild(c); });
      setVideos(grid);
      var wrap = root.querySelector('.ftp-more-wrap');
      var nwrap = doc.querySelector('.ftp-more-wrap');
      if (nwrap && wrap) { wrap.innerHTML = nwrap.innerHTML; keepLinks(wrap); } else if (wrap) { wrap.remove(); }
    }).catch(function () { a.classList.remove('is-busy'); location.href = a.getAttribute('href'); });
  });

  /* ---- seo copy */
  var seo = root.querySelector('[data-seo]');
  if (seo) {
    var t = seo.querySelector('.ftp-seo-t'), btn = seo.querySelector('[data-seo-btn]');
    if (t.scrollHeight <= t.clientHeight + 5) btn.style.display = 'none';
    btn.addEventListener('click', function () {
      var o = seo.classList.toggle('is-open');
      btn.textContent = o ? 'Read less' : 'Read more';
    });
  }
})();
